module.exports = __webpack_public_path__ + "assets/img/案例.b80a15f5.png";